export const SET_SEARCH_RESULTS = 'multiMemberSearch/SET_SEARCH_RESULTS';
export const CLEAR_SEARCH_RESULTS = 'multiMemberSearch/CLEAR_SEARCH_RESULTS';
